export enum EnumTipoCorrector {
  PT = 1,
  PTZ,
  Unidad_Remota_PT,
  No_aplica,
  Energia,
  Unidad_Remota_PTZ
}
